module.exports = __webpack_public_path__ + "img/vote-1.486f6622.png";